$(document).on("click", ".question_product,.faq_question,.footer_menu_1 p, .footer_menu_2 p", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question,.footer_menu_1 p, .footer_menu_2 p').removeClass('active');
    jQuery('.question_product,.faq_question,.footer_menu_1 p, .footer_menu_2 p').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});





 $(document).on("click", ".custom_button", function (e) {
    var video = jQuery(this).parents('.video_wrapper_custom').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
     jQuery(this).addClass('active');
 }
 });







$(document).on("click", "a[href='#compare']", function (e) {
  e.preventDefault();
  document.querySelector('#compare').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#faq']", function (e) {
  e.preventDefault();
  document.querySelector('#faq').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.landing_page_product').scrollIntoView({
    behavior: 'smooth'
  })
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}
function getDecimalPlaces(value) {
  const str = value.toString();
  if (str.includes('.')) {
    return str.split('.')[1].length;
  }
  return 0;
}
$(window).scroll(function () {
    $('.custom_counter .icons_with_text_flex').each(function () {
      var this_element =  $(this);
      if (this_element.hasClass("start_count")) {
} else {
        if (isScrolledIntoView(this) === true) {
            this_element.addClass('start_count');
$('.start_count .count_js').each(function () {
    $(this).prop('Counter', 0).animate({
            Counter: $(this).data('value')
        }, {
        duration: 2000,
        easing: 'swing',
        step: function (now) {                      
           $(this).text(parseFloat(now).toFixed(getDecimalPlaces($(this).data('value'))));
        }
    });
});
        }
      }
    });

});



$(document).on("click", ".tab_item_pdp", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tab_item_pdp').removeClass('active');
$(this).addClass('active');
$('.tab_content_pdp').hide();
$('.tab_content_pdp[data_tab="'+data_tab+'"]').show();
});





  $(window).scroll(function(){
      if ($(this).scrollTop() > 30) {
         $('body').addClass('remove_transparent');
      } else {
         $('body').removeClass('remove_transparent');
      }
  });








 






$(document).on("click", ".trigger_reviews_js_show", function (e) {
$('.review_with_text_landing_page_item.active').last().next().show();
$('.review_with_text_landing_page_item.active').last().next().next().show();
$('.review_with_text_landing_page_item.active').last().next().next().next().show();
$('.review_with_text_landing_page_item.active').last().next().next().next().next().show();
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
});



function updateCartCount() {
  $.getJSON('/cart.js', function(cart) {
    const itemCount = cart.item_count;
    $('cart-count.count-bubble').text(itemCount).css('opacity','1');
  });
}

// Function to refresh the <cart-drawer> via AJAX
async function refreshCartDrawer() {
 const response = await fetch(`${window.Shopify.routes.root}`);
  const text = await response.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  const newDrawer = doc.querySelector('#cart-drawer');

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && newDrawer) {
    cartDrawer.replaceChildren(...newDrawer.children);
  }
}

$(document).on("click", '.review_product_add', function(e) {
  e.preventDefault(); 

  var this_element = $(this);
  this_element.addClass('loading_hk');

  var quantity = 1;
  var variantId = this_element.attr('variant_id');

  // 👉 get selling plan id (if exists)
  var sellingPlanId = this_element.attr('selling_plan_id'); 
  // OR use data attribute:
  // var sellingPlanId = this_element.data('selling-plan-id');

  var items = [];

  var itemData = {
    id: variantId,
    quantity: quantity
  };

  // ✅ Add subscription ONLY if plan exists
  if (sellingPlanId && sellingPlanId !== '') {
    itemData.selling_plan = parseInt(sellingPlanId);
  }

  items.push(itemData);

  const newData = { items: items };

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify(newData),
    contentType: 'application/json',
    dataType: 'json',
    success: function(response) {

      updateCartCount();

      setTimeout(function() {
        refreshCartDrawer();

        const cartDrawer = document.querySelector("#cart-drawer");
        if(cartDrawer){
          cartDrawer.setAttribute("open", "");
        }

        this_element.removeClass('loading_hk'); 

      }, 1000);

    },
    error: function(err) {
      console.error("Add to cart error", err);
      alert("Error adding items to cart. Please try again.");
      this_element.removeClass('loading_hk');
    }
  });

});